'use strict';
import $ from 'jquery';

export default class BlogSidebarSticky {
  static init() {
    $('.single-blog-main-sidebar-share-container').each((index, el) => {
      new BlogSidebarSticky($(el));
    });
  }

  constructor($el) {
    const self = this;
    this.disableOnScroll = false;
    this.el = $el;
    this.scrollCoords = {};
    this.buildScrollCoords();
    this.el.css('top', `${$('.siteHeader').outerHeight(true) + 30}px`);
    $(window).on('scroll', this.blogPostToc.bind(this));
    this.blogPostToc();
    $('#blog-sidebar-toc a').on('click', this.onTocClick.bind(this));
    $('#blog-sidebar-toc a').on('scrollComplete', this.linkScrollComplete.bind(this));
  }

  linkScrollComplete(e) {
    this.disableOnScroll = false;
    this.el.find("a[href^='#']").parent().removeClass('active');
    $(e.currentTarget).parent().addClass('active');
  }

  onTocClick(e) {
    const self = this;
    this.disableOnScroll = true;
  }

  blogPostToc() {
    if (this.disableOnScroll) {
      return;
    }
    let scroll = $(window).scrollTop() + $('header').outerHeight();

    if ($('body').hasClass('admin-bar'))
      scroll += $('#wpadminbar').height();

    let newscroll = scroll; // + $('.navbar').outerHeight() + 100;
    if ($('#wpadminbar').length > 0)
      newscroll += $('#wpadminbar').outerHeight();
    for (var i = Object.keys(this.scrollCoords).length - 1; i >= 0; i--) {
      var offset = Object.keys(this.scrollCoords)[i];
      if (newscroll >= offset) {
        this.el.find("a[href^='#']").parent().removeClass('active');
        this.el.find("a[href^='" + this.scrollCoords[offset] + "']").parent().addClass('active');
        return false;
      }
    }
  }

  buildScrollCoords() {
    const self = this;
    this.scrollCoords = {};
    this.el.find('ol').find("a[href^='#']").each(function () {
      let id = $(this).attr('href');
      let offset = $(id).offset().top; // + $('.navbar').outerHeight();
      self.scrollCoords[Math.round(offset)] = id;
    });
  }

}
